/**
 * Indicates the probability the supplied function will execute
 */
export default (func, probability) => ({
  func,
  probability
});



// WEBPACK FOOTER //
// ./src/game/utils/createProbability.js